import { useDeliveryArea } from "@provider/app-data";
import { doesDeliverToZipcode } from "@utils";
import * as React from "react";

import AlertMessage from "./alert-message";

interface PostcodeCheckInterface {
  postcode: string;
}

export default function PostcodeCheck({ postcode }: PostcodeCheckInterface) {
  const doesDeliver = doesDeliverToZipcode(postcode, useDeliveryArea());

  return (
    <AlertMessage testID={doesDeliver ? "postcode-check-ok" : "postcode-check-buiten-gebied"} isSuccess={doesDeliver}>
      {doesDeliver
        ? "De postcode valt in het bezorggebied, je kunt je boodschappen laten bezorgen"
        : "De postcode valt helaas niet in het bezorggebied, je kunt je boodschappen wel zaterdags ophalen op de boerenmarkt."}
    </AlertMessage>
  );
}
